import { FIELDS } from './constants';

const defaultFields = [
  /*{
    field: 'commands',
    title: ' ',
    cell: 'commands',
    headerCell: 'commandsHeader',
    sortable: false,
    hidden: false,
    locked: true,
    width: 40,
  },*/
  {
    field: 'selectcommands',
    title: ' ',
    cell: 'selectcommands',
    headerCell: 'selectCommandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
  {
     key: 'inventoryId',
     field: FIELDS.INVENTORY_ID,
     title: 'Inventory Id',
     label: 'Inventory Id',
     sortable: true,
     hidden: false,
     width: 75,
  },{
     key: 'salesOrderId',
     field: FIELDS.SALES_ORDER_ID,
     title: 'Sales Order Id',
     label: 'Sales Order Id',
     sortable: true,
     hidden: false,
     width: 75,
  },{
     key: 'soDate',
     field: FIELDS.SODATE,
     title: 'SO Date',
     label: 'SO Date',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'customerName',
     field: FIELDS.CUSTOMER_NAME,
     title: 'Customer',
     label: 'Customer',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'partNumber',
     field: FIELDS.PART_NUMBER,
     title: 'Part Number',
     label: 'Part Number',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'manufacturerName',
     field: FIELDS.MANUFACTURER_NAME,
     title: 'Mfr',
     label: 'Mfr',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'unitCost',
     field: FIELDS.UNIT_COST,
     title: 'Unit Cost',
     label: 'Unit Cost',
     cell: 'formatAmount',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'charges',
     field: FIELDS.CHARGES,
     title: 'Charges',
     label: 'Charges',
     cell: 'formatAmount',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'cost',
     field: FIELDS.COST,
     title: 'Cost',
     label: 'Cost',
     cell: 'formatAmount',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'qtyAllocated',
     field: FIELDS.QTY_ALLOCATED,
     title: 'Qty Allocated',
     label: 'Qty Allocated',
     cell: 'formatSeparator',
     sortable: true,
     hidden: false,
     width: 75,
  },{
     key: 'qtyTesting',
     field: FIELDS.QTY_TESTING,
     title: 'Qty Testing',
     label: 'Qty Testing',
     cell: 'formatSeparator',
     sortable: true,
     hidden: false,
     width: 75,
  },{
     key: 'qtyShipped',
     field: FIELDS.QTY_SHIPPED,
     title: 'Qty Shipped',
     label: 'Qty Shipped',
     cell: 'formatSeparator',
     sortable: true,
     hidden: false,
     width: 75,
  },{
     key: 'qtyAvailable',
     field: FIELDS.QTY_AVAILABLE,
     title: 'Qty Available',
     label: 'Qty Available',
     cell: 'formatSeparator',
     sortable: true,
     hidden: false,
     width: 75,
  },{
     key: 'status',
     field: FIELDS.STATUS,
     title: 'Status',
     label: 'Status',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'dateCreated',
     field: FIELDS.DATE_CREATED,
     title: 'Date Allocated',
     label: 'Date Allocated',
     cell: 'formatDate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'dateModified',
     field: FIELDS.DATE_MODIFIED,
     title: 'Date Modified',
     label: 'Date Modified',
     cell: 'formatDate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'active',
     field: FIELDS.ACTIVE,
     title: 'Active',
     label: 'Active',
     cell: 'checkMark',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'companyName',
     field: FIELDS.COMPANY_NAME,
     title: 'Vendor',
     label: 'Vendor',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'vendorPartNumber',
     field: FIELDS.VENDOR_PART_NUMBER,
     title: 'Vendor PN',
     label: 'Vendor PN',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'internalPn',
     field: FIELDS.INTERNAL_PN,
     title: 'Internal PN',
     label: 'Internal PN',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'nsnNumber',
     field: FIELDS.NSNNUMBER,
     title: 'NSN',
     label: 'NSN',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'altNumber',
     field: FIELDS.ALT_NUMBER,
     title: 'Alt No',
     label: 'Alt No',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'harmonizedCode',
     field: FIELDS.HARMONIZED_CODE,
     title: 'HTS Code',
     label: 'HTS Code',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'description',
     field: FIELDS.DESCRIPTION,
     title: 'Description',
     label: 'Description',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'className',
     field: FIELDS.CLASS_NAME,
     title: 'Class',
     label: 'Class',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'categoryName',
     field: FIELDS.CATEGORY_NAME,
     title: 'Category',
     label: 'Category',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'uom',
     field: FIELDS.UOM,
     title: 'UOM',
     label: 'UOM',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'package',
     field: FIELDS.PACKAGE,
     title: 'Package',
     label: 'Package',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'piecePerPkg',
     field: FIELDS.PIECE_PER_PKG,
     title: 'SPQ',
     label: 'SPQ',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'physPkg',
     field: FIELDS.PHYS_PKG,
     title: 'Phys Pkg',
     label: 'Phys Pkg',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'leadFree',
     field: FIELDS.LEAD_FREE,
     title: 'RoHS',
     label: 'RoHS',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'tempRating',
     field: FIELDS.TEMP_RATING,
     title: 'Temp Rating',
     label: 'Temp Rating',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'partComments',
     field: FIELDS.PART_COMMENTS,
     title: 'Part Comments',
     label: 'Part Comments',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'qtyReceived',
     field: FIELDS.QTY_RECEIVED,
     title: 'Qty Received',
     label: 'Qty Received',
     cell: 'formatSeparator',
     sortable: true,
     hidden: true,
     width: 75,
  },{
     key: 'onHand',
     field: FIELDS.ON_HAND,
     title: 'On Hand',
     label: 'On Hand',
     cell: 'formatSeparator',
     sortable: true,
     hidden: true,
     width: 75,
  },{
     key: 'allocated',
     field: FIELDS.ALLOCATED,
     title: 'Allocated',
     label: 'Allocated',
     cell: 'formatSeparator',
     sortable: true,
     hidden: true,
     width: 75,
  },{
     key: 'returned',
     field: FIELDS.RETURNED,
     title: 'Returned',
     label: 'Returned',
     cell: 'formatSeparator',
     sortable: true,
     hidden: true,
     width: 75,
  },{
     key: 'destroyed',
     field: FIELDS.DESTROYED,
     title: 'Destroyed',
     label: 'Destroyed',
     cell: 'formatSeparator',
     sortable: true,
     hidden: true,
     width: 75,
  },{
     key: 'dateCode',
     field: FIELDS.DATE_CODE,
     title: 'Date Code',
     label: 'Date Code',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'lotCode',
     field: FIELDS.LOT_CODE,
     title: 'Lot Code',
     label: 'Lot Code',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'revision',
     field: FIELDS.REVISION,
     title: 'Revision',
     label: 'Revision',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'conditionName',
     field: FIELDS.CONDITION_NAME,
     title: 'Condition',
     label: 'Condition',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'countryOfOriginName',
     field: FIELDS.COUNTRY_OF_ORIGIN_NAME,
     title: 'COO',
     label: 'COO',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'qtyOnHold',
     field: FIELDS.QTY_ON_HOLD,
     title: 'Qty On Hold',
     label: 'Qty On Hold',
     cell: 'formatSeparator',
     sortable: true,
     hidden: false,
     width: 75,
  },{
     key: 'warehouseName',
     field: FIELDS.WAREHOUSE_NAME,
     title: 'Warehouse',
     label: 'Warehouse',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'location',
     field: FIELDS.LOCATION,
     title: 'Location',
     label: 'Location',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'rack',
     field: FIELDS.RACK,
     title: 'Rack',
     label: 'Rack',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'shelf',
     field: FIELDS.SHELF,
     title: 'Shelf',
     label: 'Shelf',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'bin',
     field: FIELDS.BIN,
     title: 'Bin',
     label: 'Bin',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'isSplit',
     field: FIELDS.IS_SPLIT,
     title: 'Split',
     label: 'Split',
     cell: 'checkMark',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'isQuarantined',
     field: FIELDS.IS_QUARANTINED,
     title: 'Quarantined',
     label: 'Quarantined',
     cell: 'checkMark',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'warrantyName',
     field: FIELDS.WARRANTY_NAME,
     title: 'Warranty',
     label: 'Warranty',
     sortable: true,
     hidden: true,
     width: 150,
  },
//   {
//     field: 'deletecommands',
//     title: ' ',
//     cell: 'deletecommands',
//     headerCell: 'commandsHeader',
//     sortable: true,
//     hidden: false,
//     locked: true,
//     width: 30,
//   },
]

export default defaultFields;
